<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Adăugare Destinație Document / Flux</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <form [formGroup]="formDestinatie">
        <h3 class="m-0">Destinație <span class="text-danger">(*)</span></h3>
        <mat-divider class="divider-section"></mat-divider>
        <br>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Instituție/Direcție</mat-label>
                    <input matInput [formControl]="directiiDestinatieControl" [matAutocomplete]="autoDirectiiDestinatie"
                        (blur)="onDirectiiDestinatieBlur()" />
                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                    <mat-autocomplete #autoDirectiiDestinatie="matAutocomplete"
                        [displayWith]="displayDirectiiDestinatie"
                        (optionSelected)="onDirectiiDestinatieChange($event.option.value)">
                        <mat-option *ngIf="filteredDirectiiDestinatie.length === 0" disabled>
                            Nu au fost găsite rezultate
                        </mat-option>
                        <mat-option *ngFor="let directie of filteredDirectiiDestinatie" [value]="directie">
                            {{ directie.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Compartiment/Departament</mat-label>
                    <input matInput [formControl]="compartimenteDestinatieControl"
                        [matAutocomplete]="autoCompartimenteDestinatie" (blur)="onCompartimenteDestinatieBlur()" />
                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                    <mat-autocomplete #autoCompartimenteDestinatie="matAutocomplete"
                        [displayWith]="displayCompartimenteDestinatie"
                        (optionSelected)="onCompartimenteDestinatieSelected($event.option.value)">
                        <mat-option *ngIf="showCompartimenteDestinatieMessage" disabled>
                            <span
                                *ngIf="!compartimenteDestinatieControl.value || compartimenteDestinatieControl.value.length < 2">
                                Vă rugăm să introduceți 2 caractere sau mai multe
                            </span>
                            <span
                                *ngIf="isCompartimenteDestinatieLoading && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">Căutare...</span>
                            <span
                                *ngIf="!isCompartimenteDestinatieLoading && compartimenteDestinatieLoadComplete && compartimenteDestinatie.length === 0 && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">
                                Nu au fost găsite rezultate
                            </span>
                        </mat-option>

                        <mat-option *ngFor="let compartiment of compartimenteDestinatie" [value]="compartiment">
                            {{ compartiment.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Alegeți un operator</mat-label>
                    <mat-select formControlName="user_id" (selectionChange)="onOperatoriDestinatieChange($event.value)">
                        <!-- <mat-form-field class="px-2 sticky-input">
                                <input matInput [formControl]="operatoriDestinatieControl"
                                    (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                            </mat-form-field> -->

                        <mat-option [value]="-1">-- Alegeți --</mat-option>

                        <mat-option *ngFor="let operator of filteredOperatoriDestinatie" [value]="operator.id">
                            {{ operator.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <button (click)="addDestinatieToTableData()" class="btn-search my-2 default-btn">
            Adaugă Destinație
        </button>

        <div class="row m-2">
            <table *ngIf="tableData.length > 0">
                <thead>
                    <tr>
                        <th class="pe-1">Crt.</th>
                        <th class="pe-1">Instituție/Direcție</th>
                        <th class="pe-1">Departament/Compartiment</th>
                        <th class="pe-1">Responsabil</th>
                        <th class="pe-1">Doc Original?</th>
                        <th class="pe-1">#</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of tableData; let i = index" class="table-row">
                        <td class="py-2 pe-1">{{ i + 1 }}</td>
                        <td class="py-2 pe-1">{{ row.directie_name || 'n/a' }}</td>
                        <td class="py-2 pe-1">{{ row.compartiment_name || 'n/a' }}</td>
                        <td class="py-2 pe-1">{{ row.user_name || 'n/a' }}</td>
                        <td class="py-2 pe-1">
                            <button type="button" class="action-btn update_status_active"
                                [ngClass]="(row.dosar_original ? 'action-success' : 'action-danger')"
                                (click)="checkDocOriginal(i)">
                                <img class="btn-img"
                                    [src]="row.dosar_original ? '/assets/icons/check-white.svg' : '/assets/icons/close-white.svg'" />
                            </button>
                        </td>
                        <td class="py-2 pe-1">
                            <button class="action-btn delete" (click)="deleteTableDataRow(i)">
                                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete" />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row">
            <h5 class="mb-3"><span class="text-danger">*</span> <i>Câmpuri obligatorii</i></h5>
            <div class="col d-flex gap-2 justify-content-between flex-wrap">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <div class="d-flex gap-2 flex-wrap">
                    <button class="buttons" type="submit" mat-flat-button color="primary"
                        [disabled]="tableData.length === 0" (click)="submitForm()">
                        Actualizează
                    </button>
                </div>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>